export default class InputMessage
{
  constructor(text, userId) 
  {
    this.text = text;
    this.userId = userId;
  }    
}